import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { Redirect } from 'react-router-dom';
import { AppState } from 'store';
import { useSelector } from 'react-redux';
const { Title } = Typography;

const links = [
  {
    url: 'https://www.datatracetitle.com/hubfs/NYC-ONLINE-ABSTRACT-GUIDE-03-2020.pdf',
    text: 'Online Services - User Guide',
  },
  {
    url: 'https://www.datatracetitle.com/hubfs/NYC-Online-Abstract-Tutorial.mp4',
    text: 'Online Services - Video Tutorial',
  },
  {
    url: 'https://www.datatracetitle.com/hubfs/DTNY-DocuTrax-How-To.pdf',
    text: 'DocuTrax: Document Images - User Guide',
  },
  {
    url: 'https://www.datatracetitle.com/hubfs/ARB%20Help%20FIles-02-2021-FINAL.pdf',
    text: 'DocuTrax: NYC Indices - User Guide',
  },
  {
    url: 'https://www.datatracetitle.com/hubfs/TaxTrax-User-Guide.pdf',
    text: 'TaxTrax - User Guide',
  },
];

const UserManual: React.FC = () => {
  const login = useSelector((state: AppState) => state.login);

  if (login.user?.licenseflag == 'False') {
    return <Redirect to={`/pages/license`} />;
  }

  return (
    <Card size="small">
      <Title level={3}>User Manual</Title>

      {links.map((link, index) => {
        return (
          <Row gutter={[16, 16]} key={index}>
            <Col>
              <a target="_blank" rel="noopener noreferrer" href={link.url}>
                {link.text}
              </a>
            </Col>
          </Row>
        );
      })}
    </Card>
  );
};

export default UserManual;
